export const ErrorException = (message, name, object) => {
  this.message = message;
  this.name = name;
  this.object = object;
}